import React, { useEffect, useState } from "react";
import {
  Search,
  Heart,
  User,
  ShoppingCart,
  Phone,
  Mail,
  MapPin,
  Clock,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import WhatsAppButton from "./components/WhatsAppButton";
import Footer from "./components/Footer";
import Header from "./components/Header";

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log("Form submitted:", formData);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-purple-50 via-white to-purple-50">
      <Header />

      {/* Hero Section */}
      <div className="relative h-64 bg-gradient-to-r from-purple-900 to-purple-800">
        <div className="absolute inset-0 bg-[url('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDZkGS-kNqBg4qAguhFK_dgS7ffBPKYL70Ug&s')] opacity-20 bg-cover bg-center" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-purple-900 opacity-50" />
        <div className="relative container mx-auto px-6 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-4xl font-bold mb-2">Contact Us</h1>
            <p className="text-xl text-purple-100">
              We'd love to hear from you
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-16">
          {/* Contact Information */}
          <div className="space-y-8">
            <h2 className="text-2xl font-bold mb-8 text-purple-900">
              Get in Touch
            </h2>

            <div className="space-y-6">
              {/* Contact Cards */}
              <div className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-xl">
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-purple-600 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-2 text-purple-900">
                      Visit Our Store
                    </h3>
                    <p className="text-purple-700">
                      Ambaari jewels, # 34, Ground Floor, Shop No.4, LIC layout,
                      Opp. century Indus Apartment, R R Nagar, Bangalore -
                      560098
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-xl">
                <div className="flex items-start gap-4">
                  <Phone className="w-6 h-6 text-purple-600 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-2 text-purple-900">
                      Call Us
                    </h3>
                    <p className="text-purple-700">+91 8660891204</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-xl">
                <div className="flex items-start gap-4">
                  <Mail className="w-6 h-6 text-purple-600 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-2 text-purple-900">
                      Email Us
                    </h3>
                    <p className="text-purple-700">ambaarijewels@gmail.com</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 transition-all duration-300 hover:shadow-xl">
                <div className="flex items-start gap-4">
                  <Clock className="w-6 h-6 text-purple-600 mt-1" />
                  <div>
                    <h3 className="font-semibold mb-2 text-purple-900">
                      Business Hours
                    </h3>
                    <p className="text-purple-700">
                      Monday - Sunday: 10:00 AM - 8:00 PM
                      <br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="mt-8">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.9372206442363!2d77.5106545!3d12.9117565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f11ad535177%3A0xc99fbef483ce0f4f!2sKrish%20Interiors!5e0!3m2!1sen!2sin!4v1740318019808!5m2!1sen!2sin"
                className="w-full h-64 rounded-xl shadow-md border-2 border-purple-100"
                loading="lazy"
                title="Store Location"
              />
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-xl shadow-md p-8 transition-all duration-300 hover:shadow-xl">
            <h2 className="text-2xl font-bold mb-8 text-purple-900">
              Send Us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-purple-700 mb-2">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-purple-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-purple-700 mb-2">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-purple-700 mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-purple-700 mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-2 border border-purple-200 rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-purple-400 transition-colors duration-200"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-purple-700 text-white py-3 px-6 rounded-lg hover:bg-purple-800 transition-colors duration-200 transform hover:scale-102"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>

      <WhatsAppButton />
      <Footer />
    </div>
  );
};

export default ContactPage;
